import { Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import classNames from "classnames";
import { useTeachingPreview } from "../hooks/useTeachingPreview";

export function Syllabus() {
	const { lessons } = useTeachingPreview();
	const [searchParams, setSearchParams] = useSearchParams();

	if (lessons.length === 0) {
		return null;
	}

	const firstClass = lessons[0];

	const classId = searchParams.get("class") ?? firstClass.id ?? 0;

	return (
		<div className="syllabus-container">
			{lessons.map((lesson) => {
				return (
					<div
						className={classNames(
							"lesson-item-container item-separator-small",
							{ selected: classId === lesson.id.toString() },
						)}
						onClick={() => {
							setSearchParams((prev) => {
								prev.set("class", lesson.id.toString());
								return prev;
							});
						}}
						key={lesson.id}>
						<div style={{ flex: 1 }}>
							<Typography className="normal-text bold">
								{lesson.title}
							</Typography>
						</div>
					</div>
				);
			})}
		</div>
	);
}
